import user_management_assignment_methods from './user_management_assignment_methods';
import user_management_data_methods from './user_management_data_methods';
import user_management_form_methods from './user_management_form_methods';

export default {
  ...user_management_data_methods,
  ...user_management_form_methods,
  ...user_management_assignment_methods,
};
